import { SystemSettings } from "../../../responses/systemSettings";
import { PanelEditorScope } from "../panels/panel-editor-scope";
import { Panel2DEditorDockingPanelContent } from "./content/panel2DEditorDockingPanelContent";
import { DockingPanel } from "./dockingPanel";

export class Panel2DEditorDockingPanel {
    private readonly panel: DockingPanel;
    private _visible: boolean;

    constructor(container: HTMLElement, systemSetting: SystemSettings, panelEditorScope: PanelEditorScope) {
        this._visible = false;

        const component = (
            <Panel2DEditorDockingPanelContent systemSetting={systemSetting} panelEditorScope={panelEditorScope} />
        );

        const containerRect = container.getBoundingClientRect();

        this.panel = new DockingPanel(container, "dextall-panel-2d-editor", "Panel type", component, {
            style: {
                resize: "both",
            },
            dimensionsControl: {
                preventOverlapsWithViewerToolbar: true,
                widthDimensionControl: { value: 0.33 * containerRect.width, minValue: 560 },
                heightDimensionControl: { value: 0.7 * containerRect.height, minValue: 560 },
                topOffset: 2,
                rightOffset: 2,
            },
            carefullBringToFront: true,
        });

        this.panel.addToggleFullSizeButton();

        this.panel.addVisibilityListener((x: boolean) => (this._visible = x));
    }

    get visible() {
        return this._visible;
    }

    setVisible(visibility: boolean) {
        if (this._visible === visibility) {
            return;
        }

        this._visible = visibility;
        this.panel.setVisible(visibility);
    }

    shutdown() {
        this.panel.shutdown();
    }
}
